export default function HeroSection() {
  const stats = [
    { value: '200+', label: '每日精选内容' },
    { value: '8', label: '内容板块覆盖' },
    { value: '千万', label: '用户信赖之选' },
  ];

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center bg-background-50 overflow-hidden"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-[-20%] right-[-10%] w-[60%] h-[80%] rounded-full bg-primary-100/30 blur-3xl"></div>
        <div className="absolute bottom-[-10%] left-[-5%] w-[40%] h-[50%] rounded-full bg-accent-100/20 blur-3xl"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-5 tracking-wide">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-500 animate-pulse"></span>
              每日更新 · 独家爆料
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight tracking-tight">
              今日看料<span className="text-primary-500">·</span>美好生活从今日开始
            </h1>

            <p className="font-heading text-lg md:text-xl text-foreground-600 mt-3 tracking-wide">
              聚焦热点，看遍天下新鲜事
            </p>

            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mt-5 max-w-xl mx-auto lg:mx-0">
              今日看料是一个集每日热点资讯、独家内幕爆料、话题深度讨论于一体的综合性内容平台。我们每日精选全网最热内容，涵盖时事、娱乐、生活等多个领域，为用户提供一站式的信息消费体验。无论是最新黑料、历史回顾，还是热门话题讨论，您都能在这里找到。官网持续更新最新访问地址，移动端App同步上线，让您随时随地不错过任何精彩内容。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mt-6">
              {stats.map((s) => (
                <div key={s.label} className="text-center">
                  <div className="font-heading text-xl md:text-2xl font-bold text-primary-600">
                    {s.value}
                  </div>
                  <div className="text-xs text-foreground-500 mt-0.5">{s.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-7">
              <a
                href="#carousel"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line text-lg"></i>
                立即浏览
              </a>
              <a
                href="#app"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#app')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full border-2 border-primary-500 text-primary-600 font-semibold text-sm hover:bg-primary-50 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-download-2-line text-lg"></i>
                下载App
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[350px] md:w-[380px] md:h-[460px] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20modern%20editorial%20abstract%20composition%20with%20warm%20amber%20and%20deep%20coral%20accents%2C%20flowing%20organic%20geometric%20shapes%20layered%20like%20newspaper%20fragments%2C%20dark%20sophisticated%20background%20with%20warm%20golden%20highlights%2C%20dynamic%20energy%20suggesting%20breaking%20news%20and%20information%20flow%2C%20artistic%20minimal%20design%20with%20rich%20texture%2C%20no%20text%20no%20letters&width=800&height=960&seq=hero-main-visual&orientation=portrait"
                alt="今日看料主视觉 - 热点资讯聚合平台"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/30 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}